import React from 'react';
import { observer, inject } from 'mobx-react';
import { message } from 'antd';
import GanttContainer from './GanttContainer';
import { WeaTools } from 'ecCom';
import GanttStore from '../../stores/gantt/GanttStore';
const getTop = WeaTools.WindowFunc.getTop;

export interface ganttProps {
  ganttStore: GanttStore,
  location: String
}

@inject('ganttStore')
@observer
export default class Gantt extends React.Component<ganttProps, any>{

  constructor(props){
    super(props);
    this.state={timestamp:new Date().getTime()};
  }

  clear=()=>{
    this.setState({timestamp:new Date().getTime()});
  }

  componentWillMount() {
    const { ganttStore, location } = this.props;
    let id = location['query'].id || '';
    let rootId = location['query'].rootId || location['query'].rootid || '';
    let resourceId = location['query'].resourceId || location['query'].resourceid || '';
    ganttStore.update({ id, rootId,resourceId });
  }

  componentDidMount() {
    const { ganttStore } = this.props;
    getTop()['current_ganttStore'] = ganttStore;
    ganttStore.clear=this.clear;
    ganttStore.init();
  }

  componentWillReceiveProps(nextProps){
    //前台切到甘特页面时清除message
    message.destroy();
    
    const { ganttStore,location } = nextProps;
    let id = location['query'].id || '';
    let resourceId = location['query'].resourceId || location['query'].resourceid || '';
    if (this.props.ganttStore.id != id || this.props.location != location || resourceId!='') {
      ganttStore.clear();//清除ganttContainer组件
      ganttStore.update({ id,resourceId });
      ganttStore.init();
    }
  }

  componentWillUnmount(){
    //前台切换到非甘特页面时清除message
    message.destroy();
  }

  render() {
    const { ganttStore } = this.props;
    if(ganttStore.windowTitle != ""){
      document.title = ganttStore.windowTitle;
    }
    return <GanttContainer ecId={`${this && this.props && this.props.ecId || ''}_GanttContainer@mp9exe`} key={this.state.timestamp} ganttStore={ganttStore} location={''} />
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/gantt/index.tsx